import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { ObstaclePageComponent } from './obstacle-page/obstacle-page.component'
import { ObstacleProvider4DataComponent } from './components/obstacle-layer-categories/obstacle-provider4-data/obstacle-provider4-data.component'
import { ObstacleSegmentComponent } from './components/obstacle-layer-categories/obstacle-segment-data/obstacle-segment-data.component'
import { ObstacleLayerLegendComponent } from './components/obstacle-layer-legend/obstacle-layer-legend.component'
import { ObstacleRawDetailsComponent } from './components/obstacle-raw-details/obstacle-raw-details.component'
import { ObstacleLayerConfigComponent } from './components/obstacle-layer-config/obstacle-layer-config.component'
import { SharedModule } from '../shared/shared.module'
import { ObstacleProvider1DataComponent } from './components/obstacle-layer-categories/obstacle-provider1-data/obstacle-provider1-data.component'
import { ObstacleProvider2DataComponent } from './components/obstacle-layer-categories/obstacle-provider2-data/obstacle-provider2-data.component'
import { ObstacleProvider3DataComponent } from './components/obstacle-layer-categories/obstacle-provider3-data/obstacle-provider3-data.component'
import { ObstacleHistoryControlComponent } from './components/obstacle-history-control/obstacle-history-control.component'
import { DetailsAccordionComponent } from '../shared/components/details/details-accordion/details-accordion'
import { ObstacleRoadDetailsComponent } from './components/obstacle-road-details/obstacle-road-details.component'
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { ObstacleProvider6DataComponent } from './components/obstacle-layer-categories/obstacle-provider6-data/obstacle-provider6-data.component'
import { ObstacleProvider7DataComponent } from './components/obstacle-layer-categories/obstacle-provider7-data/obstacle-provider7-data.component'
import { ObstacleProvider8DataComponent } from './components/obstacle-layer-categories/obstacle-provider8-data/obstacle-provider8-data.component'
import { ObstacleProvider9DataComponent } from './components/obstacle-layer-categories/obstacle-provider9-data/obstacle-provider9-data.component'
import { ObstacleViewActionsBarComponent } from './components/obstacle-view-actions-bar/obstacle-view-actions-bar.component'

@NgModule({
  declarations: [
    ObstaclePageComponent,
    ObstacleRawDetailsComponent,
    ObstacleRoadDetailsComponent,
    ObstacleSegmentComponent,
    ObstacleLayerLegendComponent,
    ObstacleLayerConfigComponent,
    ObstacleProvider1DataComponent,
    ObstacleProvider2DataComponent,
    ObstacleProvider3DataComponent,
    ObstacleProvider4DataComponent,
    ObstacleProvider6DataComponent,
    ObstacleProvider7DataComponent,
    ObstacleProvider8DataComponent,
    ObstacleProvider9DataComponent,
    ObstacleHistoryControlComponent,
    ObstacleViewActionsBarComponent,
  ],
  imports: [
    CommonModule,
    DragDropModule,
    SharedModule,
    DetailsAccordionComponent,
    NgbTooltipModule,
  ],
})
export class ObstacleModule {}
